// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"7c97b906","519":"9ad93c6c","877":"e54dbd9e","881":"93f3d1eb","954":"ddc60300","969":"64e363b0","982":"e41cb3cf"}[chunkId] + ".chunk.js";
};